import PageLayout from "@/components/PageLayout";
import About from "@/components/About";
import SEO from "@/components/SEO";

export default function ChiSonoPage() {
  return (
    <PageLayout>
      <SEO
        title="Chi sono"
        description="Sono la Dott.ssa Chiara Maiolo, psicologa clinica e sessuologa clinica a Chivasso. Esperta in comunicazione ipnotica, lavoro con apertura e senza giudizio."
        keywords="psicologa clinica, sessuologa clinica, Chivasso, Torino, Chiara Maiolo"
        path="/chi-sono"
      />
      <div data-testid="chi-sono-page">
        <About standalone />
      </div>
    </PageLayout>
  );
}
